<template>
    <div>
        <h4 class="textStyle">请勿关闭或刷新网页，否则将中断上传，未关闭或刷新时如果中断，会自动尝试续传</h4>
        <el-table :data="upList" border style="width: 100%">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="文件名">
            </el-table-column>
            <el-table-column prop="creatTime" show-overflow-tooltip label="添加时间">
                <template slot-scope="scope">
                    {{ scope.row.creatTime | creatTime }}
                </template>
            </el-table-column>
            <el-table-column prop="size" label="大小" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.size | fileSize }}
                </template>
            </el-table-column>
            <el-table-column prop="percentage" label="上传进度" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ (scope.row.percentage >= 0 ? scope.row.percentage : 0).toFixed(2) }}%
                </template>
            </el-table-column>
            <el-table-column prop="date" label="上传状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row | statusUp }}
                </template>
            </el-table-column>
            <el-table-column prop="date" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.percentage == -1" @click="() => tryAgain(scope)">
                        再次尝试
                    </el-button>
                    <el-button disabled size="mini" @click="() => remove(scope)"> 移除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
  data () {
    return {
      timer: null
    }
  },
  components: {},
  props: {
    upList: Array,
    speed: Boolean,
    uploading: Boolean
  },
  watch: {
    uploading (val) {
      if (val || this.speed) {
        //  开启监听 1分钟一次
        this.timer = setInterval(() => {
          this.checkStatus()
        }, 60 * 1000)
      }
      if (!val && !this.speed) {
        this.closeWatch()
      }
    }
  },
  filters: {
    fileSize (size) {
      // console.log(size / 1024);
      let sizeM = size / 1024
      if (sizeM >= 1024) {
        sizeM = (sizeM / 1024).toFixed(2) + 'M'
      } else if (sizeM >= Math.pow(1024)) {
        sizeM = (sizeM / Math.pow(1024)).toFixed(2) + 'G'
      } else {
        sizeM = sizeM.toFixed(2) + 'K'
      }
      return sizeM
    },
    statusUp (row) {
      let status = ''
      // console.log(row.percentage)
      if (row.percentage >= 100) {
        status = '已完成'
      } else if (row.percentage === 0) {
        status = '等待上传'
      } else if (row.percentage > 0 && row.percentage < 100) {
        status = '正在上传'
      } else if (row.percentage == -2) {
        status = '文件名已存在'
      } else {
        status = '上传失败'
      }
      return status
    },
    creatTime (time) {
      const timeCreat = new Date(time || 0)
      const timeString = timeCreat.getFullYear()
      const mon =
          timeCreat.getMonth() + 1 > 9
            ? timeCreat.getMonth() + 1
            : '0' + (timeCreat.getMonth() + 1)
      const day =
          timeCreat.getDate() > 9
            ? timeCreat.getDate()
            : '0' + timeCreat.getDate()
      const hour =
          timeCreat.getHours() + 1 > 9
            ? timeCreat.getHours()
            : '0' + (timeCreat.getHours() + 1)
      const min =
          timeCreat.getMinutes() > 9
            ? timeCreat.getMinutes()
            : '0' + timeCreat.getMinutes()
      const s =
          timeCreat.getSeconds() > 9
            ? timeCreat.getSeconds()
            : '0' + timeCreat.getSeconds()
      return (
        timeString + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + hour
      )
    }
  },
  created () {
    console.log('111111 created')
  },
  methods: {
    closeWatch () {
      this.timer = null
    },
    checkStatus () {
      for (let i = 0; i < this.upList.length; i++) {
        const item = this.upList[i]
        if ((item.percentage === -1 || item.percentage === -2) && item.currentPercentage > 0) {
          this.tryAgain({
            row: item,
            $index: i
          })
        }
      }
    },
    tryAgain (scope) {
      this.$emit('tryAgain', scope)
    },
    remove (scope) {
      this.$emit('remove', scope)
    }
  }
}
</script>
<style scoped>
    .dividing {
        border-bottom: 1px dashed #eee;
        margin: 1em 0;
    }

    .textStyle {
        color: red;
        margin-bottom: 0.5em;
        margin-left: 0.7em;
    }
</style>
